import { FormikContextType } from 'formik'

import {
  Checkbox,
  CheckboxProps,
  FormControlLabel,
  FormControlLabelProps,
  InputLabel
} from '@mui/material'
import { onFieldChange } from '@/utils/forms/formik'

type FieldProps<Values> = {
  formik: FormikContextType<Values>
  name: keyof Values & string
  label: string
  error?: string | boolean
  CheckboxProps?: Omit<CheckboxProps, 'name' | 'value'>
  FormControlLabelProps?: Omit<FormControlLabelProps, 'control' | 'label'>
}

export const FormikCheckbox = <Values extends Record<string, unknown>>({
  formik,
  name,
  label,
  error,
  CheckboxProps,
  FormControlLabelProps
}: FieldProps<Values>) => {
  return (
    <>
      <FormControlLabel
        label={label}
        color={error ? 'error' : 'primary'}
        control={
          <Checkbox
            size="small"
            checked={Boolean(formik.values[name])}
            onChange={(e) => onFieldChange(formik, name, e.target.checked as Values[typeof name])}
            {...CheckboxProps}
          />
        }
        {...FormControlLabelProps}
      />
      {!!error && typeof error === 'string' && <InputLabel error>{error}</InputLabel>}
    </>
  )
}
